export function remove(array, item) {
  const idx = array.indexOf(item);
  if (idx !== -1) {
    array.splice(idx, 1);
  }
  return array;
}


export function sortObject(array, type = String, key = 'label', order = 'ASC') {
  function gv(i, k, t) {
    if (t === String) {
      return i[k].toString()
        .toUpperCase();
    }
    return i[k];
  }

  array.sort((a, b) => {
    const av = gv(a, key, type);
    const bv = gv(b, key, type);
    if (av > bv) {
      return order === 'ASC' ? 1 : -1;
    }
    if (av < bv) {
      return order === 'ASC' ? -1 : 1;
    }
    return 0;
  });
  return array;
}

export function sortLabel(array, order) {
  return sortObject(array, String, 'label', order);
}

export function sortValue(array, order) {
  return sortObject(array, Number, 'value', order);
}

export default {
  remove,
  sortObject,
  sortLabel,
  sortValue,
};
